module.exports = __webpack_public_path__ + "214c25a4b623b33764c62214020ef092.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/meters/progress-writing.png
// module id = 1655
// module chunks = 0